import { AlertCircle, CheckCircle, Mic, MicOff, Info } from 'lucide-react';
import { Alert, AlertDescription } from './ui/alert';

export const StatusIndicator = ({ 
  t, 
  isListening, 
  isPaused, 
  error, 
  isSupported,
  selectedMicLabel,
  permissionGranted 
}) => {
  const getStatus = () => {
    if (!isSupported) {
      return {
        icon: <AlertCircle className="h-4 w-4" />,
        text: t('status_not_supported'),
        variant: 'destructive',
      };
    }
    if (error) {
      return {
        icon: <AlertCircle className="h-4 w-4" />,
        text: error,
        variant: 'destructive',
      };
    }
    if (isListening && !isPaused) {
      return {
        icon: <Mic className="h-4 w-4 text-red-500" />,
        text: t('status_listening'),
        variant: 'default',
        pulse: true,
      };
    }
    if (isPaused) {
      return {
        icon: <MicOff className="h-4 w-4" />,
        text: t('status_paused'),
        variant: 'default',
      };
    }
    // Show hint if permission not yet granted
    if (!permissionGranted) {
      return {
        icon: <Info className="h-4 w-4" />,
        text: t('status_ready') + ' — ' + (t('status_permission_hint') || 'Click Start and allow microphone access when prompted'),
        variant: 'default',
      };
    }
    return {
      icon: <CheckCircle className="h-4 w-4" />,
      text: t('status_ready'),
      variant: 'default',
    };
  };

  const status = getStatus();

  return (
    <div className="space-y-2">
      <Alert variant={status.variant} className="py-2">
        <div className="flex items-center gap-2">
          {status.icon}
          <AlertDescription className="flex-1">
            {status.text}
          </AlertDescription>
          {status.pulse && (
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
            </span>
          )}
        </div>
      </Alert>
      
      {selectedMicLabel && (
        <p className="text-xs text-muted-foreground flex items-center gap-1">
          <Mic className="h-3 w-3" />
          {selectedMicLabel}
        </p>
      )}
    </div>
  );
};
